import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSun, faMoon } from '@fortawesome/free-solid-svg-icons'
import { Themes } from '@commutifi-fe/ui/components/theme/constants'
import { CommutifiLogo, Flex, Layout, Switch } from '@commutifi-fe/ui'
import { useConfig } from 'shared/providers'
import { colors } from 'constants/global'
import './styles.module.scss'

/**
 * Headless layout is used to display a Commutifi branded header without any menu
 * offering features of a logged in user since the user is not yet registered or
 * he's using features that are offline (not logged in).
 *
 * NOTE that the footer language switcher will save the preferred locale in local
 * storage but won't update account preference since the user is offline
 */
function HeadlessLayout({ children, className }: { children: React.ReactNode; className?: string }) {
  const {
    locale,
    changeLocale,
    theme: { currentTheme },
    changeTheme
  } = useConfig()
  const handleToggleTheme = () => changeTheme(currentTheme === Themes.DARK ? Themes.LIGHT : Themes.DARK)

  return (
    <Layout className="app-headless-layout">
      <div className={className || 'app-headless-layout-content'}>
        <Layout.Header>
          <CommutifiLogo fill={colors.primary400} height={40} />
        </Layout.Header>
        <Layout.Content>{children}</Layout.Content>
      </div>
      <Layout.CommutifiFooter
        languageSwitcher={<Layout.CommutifiFooter.OfflineLocaleSelector locale={locale} onChange={changeLocale} />}
      >
        <Flex align="center">
          <Switch
            checked={currentTheme === Themes.DARK}
            checkedChildren={<FontAwesomeIcon icon={faSun} />}
            onClick={handleToggleTheme}
            unCheckedChildren={<FontAwesomeIcon icon={faMoon} />}
          />
        </Flex>
      </Layout.CommutifiFooter>
    </Layout>
  )
}

export default HeadlessLayout
